<template>
    <div class="board-comment p2 flex ">
            <div class="user-bubble p2 semibold white mr2 justify-start" style="height: fit-content;">{{username}}</div>
            <div class="bg-color-lightpink text-bubble col-12 p2">
                <!-- <div class="msg-deco"></div> -->
                <p class="p2 h4 regular">{{comment}}</p>
                <p class="comment-time pr2 pt2 text-right p-small"> am {{fancyDate}}, um {{fancyTime}} Uhr</p>
            </div>
    </div>
</template>
<script>
export default {
    name: "Comment",
    props: {
        username: String, 
        posted_at: String,
        comment: String

    },
    computed: {
        fancyDate(){
        var year = this.posted_at.slice(0, 4)
        var month = this.posted_at.slice(5, 7)
        var day = this.posted_at.slice(8, 10)
        return day + '.' + month + '.' + year
      },
      fancyTime(){
          var time = this.posted_at.slice(11, -3)
          return time
      }
    }
}
</script>
<style>

</style>